import React from 'react';
import { Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import WalletPanel from '../components/wallet/WalletPanel';

const Wallet: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <Space style={{ marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/profile')}>Back to Profile</Button>
      </Space>
      <WalletPanel />
    </div>
  );
};

export default Wallet;
